module.exports = __webpack_public_path__ + "img/full4-min.018b2a42.png";